export const cacheImages = (images) => {
  // This relies on the browser caching mechanism. All we're doing here is
  // creating an image element and setting the source.

  images.forEach((src) => {
    const image = new Image();
    image.src = src;
  });
}
